import localForage from "localforage/src/localforage.js";

let watching = false;

const probe = () => {
  localForage.length().catch(() => {});
};

function watchStorageConnection() {
  if (watching) return;

  watching = true;

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      probe();
    }
  });

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      probe();
    }
  });
}

export { watchStorageConnection };
